<div class="section-title text-center">
  {{ "Get Ready with Us to Interview Stage" | translate }}
</div>
<div class="mx-4">
  <div class="first-card-container col-md-12 col-lg-8">
    <img class="first-img" src="../../../assets/img/person.png" />

    <div class="first-card-text">
      <div class="description-title">
        {{ "Career Coach with Human" | translate }}
      </div>
      <div class="title">
        {{ "Business Coaching Can Change Everything" | translate }}
      </div>
      <div class="description">
        {{ "Ready to reach your goals" | translate }}
      </div>
      <button class="border-button" routerLink="/careerCoach">
        {{ "See More" | translate }}
      </button>
    </div>
  </div>

  <div class="second-card-container col-md-12 col-lg-8">
    <div class="second-card-text">
      <div class="description-title">
        {{ "Interview Training with AI" | translate }}
      </div>
      <div class="title">
        {{ "Try online training with our AI module" | translate }}
      </div>
      <div class="description">
        {{ "Enhance your interview skills" | translate }}
      </div>
      <button class="border-button" routerLink="/soon">
        {{ "See More" | translate }}
      </button>
    </div>
    <img class="second-img" src="../../../assets/img/robote2.png" />
  </div>
</div>
